<ng-container *ngIf="action$ | async as action">
  <p-button icon="pi pi-hidden" [ngClass]="action.name" [label]="action.description" ntapDebounceClick
    (onClick)="executeAction($event)" [disabled]="(isDisabled$ | async) ?? true" [pTooltip]="action.tooltip ?? ''"
    tooltipPosition="left"></p-button>
</ng-container>
<ng-container *ngIf="showDialog">
  <p-dialog [resizable]="false" [(visible)]="showDialog" [modal]="true" [draggable]="false" [resizable]="false"
    [style]="{width: '100vw', height: '100vh'}" appendTo="body">
    <h2>Odaberite pojavni oblik</h2>
    <app-odaberi-pojavni-izlucivanje (itemSelected)="onSelectedItem($event)"></app-odaberi-pojavni-izlucivanje>
  </p-dialog>
</ng-container>